/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Folder_FromInputs */

const cs_field_folder_from = /** @type {(inputs: Field_Folder_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Složka z`)
};

const en_field_folder_from = /** @type {(inputs: Field_Folder_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder from`)
};

/**
* | output |
* | --- |
* | "Folder from" |
*
* @param {Field_Folder_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_folder_from = /** @type {((inputs?: Field_Folder_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Folder_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_folder_from(inputs)
	return cs_field_folder_from(inputs)
});